import { parseUnits } from '@ethersproject/units'
import {
  ButtonMenu,
  ButtonMenuItem,
  CloseIcon,
  Heading,
  IconButton,
  InjectedModalProps,
  ModalBody,
  ModalContainer,
  ModalTitle,
  useMatchBreakpoints,
  Text,
} from '@noahswap/uikit'
import { useWeb3React } from '@noahswap/wagmi'
import { useState, useMemo } from 'react'
import { useTranslation, languageList } from '@noahswap/localization'
import styled from 'styled-components'
import { ChainLogo } from 'components/Logo/ChainLogo'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`

const SelectBtn = styled.div`
  display: flex;
  padding: 19px;
  font-size: 20px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;

  &.active {
    border-color: #000;
    background: #ffe169;
  }
`

const LanguageModal: React.FC<React.PropsWithChildren<InjectedModalProps>> = ({ onDismiss }) => {
  const { currentLanguage, setLanguage, t } = useTranslation()

  const { isMobile } = useMatchBreakpoints()
  const handleSetLanguage = (lang) => {
    setLanguage(lang)
    onDismiss()
  }

  return (
    <ModalContainer title={t('noah182')} $minWidth={isMobile ? '100%' : '418px'}>
      <ModalHeader>
        <ModalTitle>
          <Heading>{t('noah182')}</Heading>
        </ModalTitle>
        <IconButton variant="text" onClick={onDismiss}>
          <CloseIcon width="24px" color="#000" />
        </IconButton>
      </ModalHeader>
      <ModalBody p="0 24px 24px 24px" width="100%">
        {languageList.map((lang) => (
          <SelectBtn
            className={lang.code === currentLanguage?.code ? 'active' : undefined}
            key={lang.code}
            style={{ justifyContent: 'flex-start' }}
            onClick={() => handleSetLanguage(lang)}
          >
            <Text fontSize={20} ml={12}>
              {lang.language}
            </Text>
          </SelectBtn>
        ))}
      </ModalBody>
    </ModalContainer>
  )
}

export default LanguageModal
